import { Component } from '@angular/core';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  Icici_privacy_url = environment.Icici_privacy_url;
  mailto = environment.mailto;
  bankLogin = environment.bankLogin 
}
